// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2NaFE","gfeWrapper":"CalendarEvent_gfeWrapper__21tcY"};